import { UserSchema } from "./schema";

export enum UserInvitationType {
    Email,
    UserFullname,
}

export const userInvitationOptions = [
    { label: "Email Address", value: UserInvitationType.Email },
    { label: "Both Last Name and First Name", value: UserInvitationType.UserFullname },
];




export enum ModalType {
    QueryForm,
    QueryResult,
    UserForm,
    QueryUserThenAddClient,
}


export const initialUserData: UserSchema = {
    type: UserInvitationType.Email,
    email: "",
    firstName: "",
    lastName: "",
};

export type cropModel = {
    x: number;
    y: number;
    width: number;
    height: number;
}
